export default __webpack_public_path__ + "static/media/ins-aktywacja.4371edde.jpg";